import { useMemo } from "react";
import { MessageSquareWarning } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { fmtInt, fmtPct } from "@/lib/format";

export default function MotivosFrequentesCard({ prospectos = [] }) {
  const data = useMemo(() => {
    const counter = new Map();
    for (const p of prospectos) {
      const m = (p.motivo || "").trim();
      if (!m) continue;
      counter.set(m, (counter.get(m) || 0) + 1);
    }
    const arr = [...counter.entries()].sort((a, b) => b[1] - a[1]);
    return arr;
  }, [prospectos]);

  const total = data.reduce((s, [, n]) => s + n, 0);
  const max = data[0]?.[1] || 1;

  return (
    <div className="rounded-xl border border-border bg-card p-5" data-testid="motivos-frequentes">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <div className="flex items-center gap-2">
          <MessageSquareWarning className="w-4 h-4 text-primary" />
          <h3 className="font-heading font-semibold text-lg">Motivos mais frequentes</h3>
        </div>
        <Badge variant="outline">Guia decisões de expansão</Badge>
      </div>
      <p className="text-xs text-muted-foreground mb-4">
        Os motivos abaixo aparecem mais nos prospectos sem viabilidade — considere-os ao planejar cobertura, infra e portfólio.
      </p>

      {data.length === 0 && (
        <div className="text-sm text-muted-foreground">Nenhum motivo registrado ainda.</div>
      )}

      <div className="space-y-2.5">
        {data.slice(0, 8).map(([motivo, count]) => (
          <div key={motivo} className="space-y-1" data-testid={`motivo-item-${motivo}`}>
            <div className="flex items-center justify-between gap-3 text-sm">
              <span className="truncate">{motivo}</span>
              <span className="tabular-nums text-xs text-muted-foreground">
                {fmtInt(count)} · {fmtPct((count / total) * 100)}
              </span>
            </div>
            <Progress value={(count / max) * 100} className="h-1.5" />
          </div>
        ))}
      </div>
    </div>
  );
}
